// widgets/InventoryChart.jsx
import React, { useEffect, useState } from 'react';
import { api } from '../scripts/api';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts'; // npm i recharts
import '../App.css';
import './Widgets.css';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28EFF', '#FF6384', '#36A2EB', '#FFCE56'];

export default function InventoryChart() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: summary } = await api.get('/reports/summary', {
          params: { table: 'all_inventory' },
        });
        // Transform byColor to chart data
        const chartData = summary.byColor.map(({ color_code, n }) => ({
          name: color_code || 'Unknown',
          value: n,
        }));
        setData(chartData);
      } catch (e) {
        setError(e?.response?.data?.error || 'Failed to load chart data');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <div className="widget-loading">Loading chart...</div>;
  if (error) return <div className="widget-error">{error}</div>;

  return (
    <div className="widget inventory-chart">
      <h3 className="widget-title">Inventory by Status/Color</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}